import {Component, EventEmitter, Input, OnInit, Output, Inject, NgZone, OnDestroy} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {AddOpportunityService} from "@app/features/customers/add-opportunity/service/add-opportunity.service";
import {SharedModalService} from "@app/shared-modal/service/shared-modal.service";
import { IntegrationsService } from '@app/features/company-settings/integrations/services/integrations.service';
import {AuthService, HybridFactory} from "@app/core";
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ICsDropDown } from '@app/shared/cs-components/cs-components.interface';
import { ICsDdItem } from '@app/shared/cs-components/cs-drop-down/cs-drop-down.interface';

declare var $: any;
declare var tinymce: any;

@Component({
  selector: 'app-cs-call-log-modal',
  templateUrl: './call-log-modal.component.html',
  styleUrls: ['./call-log-modal.component.scss']
})
export class CallLogModalComponent implements OnInit, OnDestroy {
  callForm: FormGroup;
  customerCallDetails: object;
  callType = [{ id: 'Incoming Call', value: 'Inbound call' }, { id: 'Outgoing Call', value: 'Outbound call' }];
  scheduled: boolean = true;
  editId:any;
  subscriptions:any = {};
  callActivityShow: boolean = false;
  activityIsScheduled: Array<any> = [];
  completed: boolean = true;
  scheduledData: any;
  saveDisabled:boolean = false;
  isContactNotFound : boolean = false ;
  todayActivityId:any;
  showAddNewTemplate = false;
  showTemplateList: boolean = false;
  tinyMCEIntervel: any;
  editor: any;
  customTagsList: any[] = [];
  customTagForm: FormGroup;
  customFieldForm: FormGroup;
  customFields = [];
  customFieldsDirectResponse: any = null;
  showRecommendation = false;
  selectedCallNoteTemplate: any;
  isCallCustomFieldEnabled = false;
  getCustomFieldCall:any;
  // customFieldInputs: any = {};
  @Input() customerId: number;
  @Input() opportunityId: number;
  @Input() showCallLogModal: boolean = false;
  @Input() editCallData:any;
  @Input() activityList:any;
  @Input() completedActivityData: any;
  @Input() showCallCustomFields = false;
  @Input() showCallNoteTemplateOption = false;
  @Output() onSave: EventEmitter<any> = new EventEmitter();
  @Input() userInfo:any;
  @Input() callinfo:any;
  @Output() onClose: EventEmitter<any> = new EventEmitter();
  @Input() usersList: any;
  users: any = [];
  selectedUsersList: any = [];
  @Input() screen = '';
  @Input() isNotificationPopup: boolean = false;
  // Dialpad permissions (readaccess/writeaccess) passed by the notification bar; only used when isNotificationPopup
  @Input() dialpadAccess: any = {};
  // Distinct from userInfo.dialpad/callinfo.dialpad (existing "call came via Dialpad
  // integration" signals) - this flag means "this modal instance belongs to the new
  // Dial Pad UI feature" and gates Dial-Pad-specific display/behavior below.
  @Input() dialPad: boolean = false;
  onlyArchivedFound = false;
  @Output() sendValue = new EventEmitter<{ callId: string, callstate: string }>();
  


  constructor(private fb : FormBuilder,
              private opportunityService: AddOpportunityService,
              private integrationsService:IntegrationsService,
              private sharedModalService: SharedModalService,
              private zone: NgZone,
              private authService: AuthService,
              @Inject('confirmationBoxHelper') private confirmationBoxHelper,
              @Inject('$scope') private ajsScope,
              private sanitizer: DomSanitizer){
      this.isCallCustomFieldEnabled = this.authService.permitted(['UseCallFields.readaccess']) === true;
  }

    ngOnInit() {
        this.customTagForm = this.fb.group({});
        if(this.showCallCustomFields) {
            this.opportunityService.listCallCustomFields().subscribe((res: any) => {
                this.getCustomFieldCall = res;
                this.buildCustomeFieldForm(res);
                this.customFieldsDirectResponse = res['customCallField'];
                // To show the list in this specific order, we mapped like this
                if(res['customCallField']['Reason for call']) {
                    this.customFields.push({key: 'Reason for call', value: res['customCallField']['Reason for call']})
                }
                if(res['customCallField']['Type of call']) {
                    this.customFields.push({key:'Type of call', value: res['customCallField']['Type of call']})
                }
                if(res['customCallField']['Outcome of call']) {
                    this.customFields.push({key:'Outcome of call', value: res['customCallField']['Outcome of call']})
                }
                // Dial Pad only - built once here (not from the template) so app-cs-drop-down
                // receives a stable object reference. It only runs its item setup once, in its
                // own ngOnInit, and has no ngOnChanges - a fresh object on every change-detection
                // cycle (e.g. from calling this inline in the template) leaves later items
                // without an itemTemplateType, which throws and silently breaks rendering for
                // the whole list.
                this.customFields.forEach((cf: any) => {
                    cf.ddConfig = this.buildCustomFieldDdConfig(cf);
                });
                let isValidArray = [];
                if(this.customFields.length) {
                    this.customFields.forEach((cfObj) => {
                        const isValidObj = !!cfObj.value.find((cf) => cf.archived == 0);
                        if(!isValidObj) {
                            isValidArray.push(false);
                        } else {
                            isValidArray.push(true);
                        }
                    });
                    this.onlyArchivedFound = !isValidArray.includes(true);
                }
                this.patchEditedCallCustomFields();
            });
        }
        this.getUserList();

    }

    
    buildCustomeFieldForm(field:any){
        let csof: any = {};
        Object.entries(field['customCallField']).forEach((item) => {
            csof[item[0]] = new FormControl('', Validators.required);
        });
        this.customFieldForm = this.fb.group(csof);
    }

    // Patches customFieldForm from editCallData once customFieldsDirectResponse/customFieldForm
    // are actually populated (both only arrive after listCallCustomFields() resolves in
    // ngOnInit). Called both from the ngOnChanges edit-branch's timeout (handles the common
    // case where the API already responded) and again once listCallCustomFields() resolves
    // (handles a slower API response, where the timeout would otherwise fire before the
    // data existed) - safe to call twice, it just reassigns the same values.
    patchEditedCallCustomFields() {
        if (!this.editCallData || !this.editCallData.communications || !this.customFieldsDirectResponse || !this.customFieldForm) {
            return;
        }
        const cfs = this.editCallData.communications['customFields'];
        if (!cfs) {
            return;
        }
        const customFieldsDirectResponse = this.customFieldsDirectResponse;
        let editedCfs: any = {};
        Object.entries(cfs).forEach((kvArray: any) => {
            if (kvArray[1] && customFieldsDirectResponse[kvArray[0]]) {
                editedCfs[kvArray[0]] = customFieldsDirectResponse[kvArray[0]].find((f: any) => f.id == kvArray[1]);
            }
        });
        this.customFieldForm.patchValue(editedCfs);
        this.refreshCustomFieldDdTogglerText();
    }

    ngOnChanges(changes){
        if(changes.showCallLogModal){
            if (this.editCallData &&
                this.editCallData.communications &&
                this.editCallData.communications.opportunity) {
                this.screen = 'opportunity_notes';
                this.getUserList();
            }
            if (this.getCustomFieldCall) {
                this.buildCustomeFieldForm(this.getCustomFieldCall);
            }
            if(this.showCallLogModal){
                this.getUserList();
                if (this.editCallData == null) {
                    let showContent = 'call';
                    if (this.activityList) {
                       /* for (var filter = 0; filter < this.activityList.length; filter++) {
                            // for (var record = 0; record < this.activityList[filter]['records'].length; record++) {
                                if (this.activityList[filter]['isScheduled'] == 'true' && this.activityList[filter]['activityStatus'] != 'Completed'
                                    && this.activityList[filter]['activityType'].toLowerCase() == showContent.toLowerCase())
                                    this.activityIsScheduled.push(this.activityList[filter])
                            // }
                        }*/
                        if (this.activityList.length != 0 && this.activityList[0].length != 0) {
                            this.callActivityShow = true;
                            for (let i = 0; i <= this.activityList[1].length; i++) {
                                if(this.activityList[1][i] && this.activityList[1][i].template) {
                                    this.selectedCallNoteTemplate = this.activityList[1][i].template;
                                    this.showRecommendation = true;
                                    break;
                                }
                            }
                            this.completed = true
                        } else {
                            this.callActivityShow = false
                            this.completed = false
                        }
                    }
                    if(this.completedActivityData && (this.completedActivityData.template || this.completedActivityData.templateName)) {
                        this.selectedCallNoteTemplate = this.completedActivityData;
                        this.showRecommendation = true;
                    }
                    this.buildForm();
                    setTimeout(() => {
                        this.todayActivity()
                    }, 500);
                    $(".modal-header").css("background", "#5E7F7D");
                    $('.callLogModal').modal('show');
                    $(".modal-dialog").addClass("modal-dialog-open");
                    // setTimeout(() => {
                    //     this.updateTinyMCEValues();
                    // }, 100);
                }
                else{
                    if (this.editCallData['activityType'] == 'Call') {
                        this.editId = this.editCallData.communications.phoneId
                        this.callActivityShow = false;
                        this.buildForm()
                        this.callForm.patchValue({
                            "contactTelephoneId": this.editCallData.communications.contactNumberId,
                            "note":  this.editCallData.communications.phoneCallNote,
                            "callType": this.editCallData.communications.calltype
                        });
                        setTimeout(() => {
                            this.patchEditedCallCustomFields();
                            // increased 500 ms extra to get customFieldsDirectResponse
                        }, 1500);
                        $(".modal-header").css("background", "#5E6D7F")
                        $('#modalPopUp').modal('show');
                        // $(".modal-dialog").css("height", "450px");
                        $(".modal-dialog").addClass("modal-dialog-open")
                        $('.callLogModal').addClass('in');
                        // setTimeout(() => {
                        //     this.updateTinyMCEValues();
                        // }, 100);
                    }
                }
            }
        }
        if (this.completedActivityData && (this.completedActivityData['template'] == null || (this.completedActivityData['template']['name'] == null && this.completedActivityData['template']['customTags'] == null && this.completedActivityData['template']['message'] == null))){
            // this.showCallNoteTemplateOption = false;
            this.showRecommendation = false;
            this.getUserList();
        }
        if(changes.customerId && this.customerId){
          this.getCustomerCall();
        }

        // EDIT MODE
        // editCallData reaches this branch in two different shapes depending on the
        // caller: notification-pop-up's live-call widget builds a flat {note,
        // customCallField} object (contact number/call type are shown read-only from
        // the live call there, not part of this form), while the Communication tab
        // (filter-navbar) passes the raw activity record, which nests these fields
        // under `.communications` - the same shape the non-dialpad edit branch above
        // reads - and does expose contact number/call type as editable fields.
        if (this.userInfo && this.userInfo.dialpad === 1 && changes['editCallData'] && this.editCallData ) {
            const communications = this.editCallData.communications;
            this.callForm.patchValue(communications ? {
                "contactTelephoneId": communications.contactNumberId,
                "note": communications.phoneCallNote,
                "callType": communications.calltype
            } : {
                note: this.editCallData.note || ''
            });

            setTimeout(() => {
                const cfs = communications ? communications['customFields'] : this.editCallData.customCallField;
                let editedCfs: any = {};
                Object.entries(cfs || {}).forEach((kvArray) => {
                    if (kvArray[1]){
                        editedCfs[kvArray[0]] = this.customFieldsDirectResponse[kvArray[0]].find((f: any) => f.id == kvArray[1]);
                    }
                });
                this.customFieldForm.patchValue(editedCfs);
                this.refreshCustomFieldDdTogglerText();
                // increased 500 ms extra to get customFieldsDirectResponse
            }, 1500);
        }



        // ADD MODE (API returned no data)
        if (this.userInfo && this.userInfo.dialpad === 1 && changes['editCallData'] && this.editCallData === null) {
            this.callForm.reset({
                activityType: 'Call',
                callType: 'Outgoing Call'
            });
        }
    }

    getCustomerCall() {
        this.opportunityService.getCustomerContact(this.customerId).subscribe(
            data => {
				if (Object.values(data).length) {
                    this.customerCallDetails = data;
				}else{
					this.isContactNotFound =true;
				}
			}
        )
    }

    todayActivity() {
        this.opportunityService.getScheduledEmail(this.opportunityId,'Call').subscribe((resp: any) => {
            if (resp) {
                if (resp.length && resp[0].length) {
                    this.callActivityShow = true;
                    this.completed = true;
                    this.todayActivityId = resp[0];
                }
                else {
                    this.callActivityShow = false;
                    this.completed = false;
                }
            }
        })
    }

    isFieldsValid(cf: any[]) {
        const isValidElement = cf.find((cfElement) => cfElement.archived === 0);
        return this.editId ? true : !!isValidElement;
    }

    buildForm(){
        this.callForm = this.fb.group({
            "contactTelephoneId": ["", Validators.required],
            "activityType": ["Call"],
            "note": [""],
            "customerId": [""],
            "callType": ["Outgoing Call", Validators.required]
        });
    }

    closeModal(emitEvent = true){
        this.editId = null
		this.callForm.controls['activityType'].setValue('')
		this.callForm.controls['customerId'].setValue('')
		this.callForm.controls['note'].setValue('');
        this.editCallData = undefined;
        this.scheduledData = undefined;
        if(this.screen == 'opportunity_call_log' || this.screen == 'opportunity'){
            this.scheduled = true;
        } else {
            this.scheduled = false;
        }
        this.activityIsScheduled = [];
        this.callActivityShow = false;
        this.showTemplateList = false;
        this.customTagForm = new FormGroup({});
        this.customFieldForm.reset();
        this.customTagsList = [];
        this.showRecommendation = false;
        this.completedActivityData = null;
        this.selectedCallNoteTemplate = null;
        $('.callLogModal').modal('hide');
        $("#call-log-modal-dialogue").removeClass("modal-dialog-open");
        if(emitEvent)
            this.onClose.emit(false);
    }

    isScheduledActivity(event) {
        this.scheduled = event.target.checked
    }

    completeActivity(event) {
		this.completed = event.target.checked
	}

    saveCall(type?: string) {
        if(type == 'dialpad'){
           
            this.saveDisabled = true
            this.callForm.get('customerId').setValue(this.customerId);
            let callData = this.callForm.value;
           
            if(this.customTagsList && this.customTagsList.length) {
                callData.customTags = this.customTagForm.value;
            }
            if(this.customFieldForm.valid && this.customFieldForm.value) {
                callData.callCustomField = this.customFieldForm.value;
            }

            // Communication tab only (this is the sole caller that ever sets `callinfo` -
            // see filter-navbar.component.ts): the dialpadActivityCall upsert needs
            // `communicationId` in the payload to be the activity's tablePkId, not its
            // communicationId, to correctly match/update this record.
            callData.communicationId = this.editCallData && this.editCallData.communications && this.editCallData.communications.tablePkId;
            this.integrationsService.postdialpadActivityCall(callData).subscribe(resp => {
                // Note: some backends omit `statusCode` on success - only treat it as a
                //      failure when the field is present and explicitly not 200.
                if (resp && (resp['statusCode'] === undefined || resp['statusCode'] == 200)) {
                    // postdialpadActivityCall already upserts the record (updates it when
                    // communicationId matches an existing call, adds it otherwise) - the
                    // `dialpad` flag tells the parent this save is already done, so it only
                    // needs to do its post-save housekeeping instead of performing its own
                    // (wrongly add-branched) save on top of this one. `callinfo` is only ever
                    // bound by filter-navbar, so this shape change can't reach any other consumer.
                    this.onSave.emit({ dialpad: true, isScheduled: this.scheduled, isUpdate: !!this.editId });
                    this.closeModal();
                }
                else if (resp['error'] != 200) {
                }
            });

        }else {
            this.saveDisabled = true
            this.callForm.get('customerId').setValue(this.customerId);
            let callData = this.callForm.value;
            if (this.completed) {
                callData = this.callForm.value
                let activityId = this.todayActivityId;
                /*if (this.activityIsScheduled.length != 0) {
                    for (var i = 0; i < this.activityIsScheduled.length; i++) {
                        activityId.push(this.activityIsScheduled[i]['activity_id'])
                    }
                } else {
                    if (this.scheduledData) {
                        if (this.scheduledData.hasOwnProperty('activity_id')) {
                            activityId.push(this.scheduledData.activity_id)
                        } else {
                            activityId.push(this.scheduledData.activityId)
                        }
                    }
                }*/
                callData.activityIds = activityId
                if (this.todayActivityId) {
                    callData.activityIds = this.todayActivityId;
                }
            }
            if(this.customTagsList && this.customTagsList.length) {
                callData.customTags = this.customTagForm.value;
            }
            if(this.customFieldForm.valid && this.customFieldForm.value) {
                callData.callCustomField = this.customFieldForm.value;
            }
            // this.editId = event.editId;
            // callData.activityIds = this.activityEmail;
            let url;
            if (this.editId) {
                callData['opportunityId'] = this.opportunityId;
                this.screen == 'opportunity_notes' ? callData['communicationId'] = this.editCallData.communications.tablePkId : callData['communicationId'] = this.editCallData.communications.communicationId;
                url = `sales/edit_opportunity_call/${this.editId}`
            } else {
                url = `sales/opportunityActivityCall/${this.opportunityId}`
            }
            callData['selectedUsersList'] = this.selectedUsersList.length > 0 ? this.selectedUsersList : [];
            this.opportunityService.createOpportunityCall(callData, url).subscribe(
                data => {
                    this.sharedModalService.updateModalStatus('opportunity', 'call', false);
                    // If this schedule, open the schedule activity modal
                    this.onSave.emit(this.scheduled);
                    this.closeModal();
                    this.saveDisabled = false;
                    // if (this.scheduledData) {
                    //     if (this.scheduledData.hasOwnProperty('activityId')) {
                            this.opportunityService.refreshCompleteActivity('complete');
                    //     }
                    // }
                });
            }
    }
    
    getPhoneIcon(state: string): string {
        const icons = {
            'ringing': '/images/ringing.svg',
            'connected': '/images/Phone.svg',
            'hangup': '/images/Stacked.svg',
            'recap_summary': '/images/Stacked.svg',
            'hold': '/images/Pause.svg',
            'missed': '/images/MissedCall.svg',
            'conflictedClient': '/images/ConflictedCall.svg'
        };
        return icons[state] || '/images/Phone.svg';
    }

    // Accepts both the raw Dialpad value ('outbound', from live PubNub) and 'Outbound call' (from the API).
    isOutboundCall(call: any): boolean {
        return !!call && typeof call.direction === 'string' && call.direction.toLowerCase().indexOf('outbound') === 0;
    }

    getDisplayIcon(call: any): string {
        if (call && call.matchfound === 1 && call.state !== 'hold' && call.state !== 'missed') {
            return '/images/ConflictedCall.svg';
        }
        // Superseded: the template now shows the call-activity outgoing icon (fa-phone-flip)
        // for a connected outbound call instead of an image.
        // if (call && call.state === 'connected' && call.direction === 'Outbound call') {
        //     return '/images/OutboundCall.svg';
        // }
        return this.getPhoneIcon(call ? call.state : undefined);
    }

    // Note: a plain <a href> only navigates reliably when the current route is already
    //      AngularJS/html5Mode-owned - on any other route (e.g. an Angular-7-owned route)
    //      the click isn't picked up. HybridFactory.navigate() is the app's sanctioned way
    //      to cross frameworks regardless of the current route (see notification-pop-up
    //      .component.ts's goToAddNewCustomer, which uses the same call for this same link).
    goToAddNewCustomer(event: MouseEvent) {
        event.preventDefault();
        HybridFactory.navigate('/customers/new_customer/1/new', {
            type: 'dialpad',
            callId: this.userInfo ? this.userInfo.callId : null,
            number: this.userInfo ? this.userInfo.contactnumber : null
        });
    }

    closeModalConfirmation() {
        if (this.isNotificationPopup) {
            // Notification popup close (drag-line / Escape) closes straight away -
            // no discard-confirmation prompt for this entry point.
            this.closeModal();
            return;
        }
        this.confirmationBoxHelper.getConfirmation('Are you sure you want to discard the log call?', this.ajsScope)
            .then(() => {
                this.closeModal();
            }).catch(() => { });
    }

    setTemplateDetails(selectedTemplate) {
        selectedTemplate.message = selectedTemplate.message ? selectedTemplate.message : selectedTemplate.value;
        selectedTemplate.message = selectedTemplate.template ? selectedTemplate.template.message : selectedTemplate.message;
        this.callForm.controls['note'].setValue(selectedTemplate['message']);
        if(selectedTemplate.customTags || (selectedTemplate.template && selectedTemplate.template.customTags)) {
            this.customTagForm = new FormGroup({});
            let customTagsList = JSON.parse(selectedTemplate.customTags || selectedTemplate.template.customTags);
            customTagsList = customTagsList.map((ct) => {
                ct.name = ct.name.replaceAll('{', '').replaceAll('}', '');
                this.customTagForm.addControl(ct.name, new FormControl('', Validators.required));
                return ct;
            });
            this.customTagsList = customTagsList;
        } else {
            this.customTagsList = [];
            this.customTagForm = new FormGroup({});
        }
        // this.updateTinyMCEValues();
        $(".template-wrapper").removeClass("template-open")
        this.showTemplateList = false;
    }

    showTemplateOptions() {
        $(".template-wrapper").addClass("template-open");
        this.showTemplateList = true;
        $("#emailcontent").addClass("overlay");
    }

    cancelTemplate() {
        $("#emailcontent").removeClass("overlay");
        $(".template-wrapper").removeClass("template-open");
        this.showTemplateList = false;
    }

    onChange = () => {
      const message = this.callForm.value.note;
      if(this.showCallNoteTemplateOption) {
          this.customTagsList.forEach((ct) => {
              if (!message.includes(`>{${ct.name}}</`) && !this.customTagForm.controls[ct.name].value) {
                  this.customTagForm.controls[ct.name].setValidators(Validators.nullValidator);
                  this.customTagForm.controls[ct.name].disable();
              }
          })
      }
    };

    replaceCustomTags(tagName: any) {
        const replacingValue = this.customTagForm.value[tagName.replaceAll('{', '').replaceAll('}', '')];
        if(replacingValue) {
            const iframe = $('quill-editor');
            const cts = $("span[data-value='"+tagName+"']", iframe.contents())
            cts.each((index, ct) => {
                $(ct).find('span').html(replacingValue);
                $(ct).removeClass('mention custom_tag');
            });
            const updatedNote = iframe.contents().find('.ql-editor')[0].innerHTML;
            this.callForm.controls.note.setValue(updatedNote);
        }
    }
    ngOnDestroy(){
        this.opportunityService.refreshCompleteActivity(null);
        this.customFields = [];
    }

    onContentChange(event) {
        if (event.text === '\n') {
            this.saveDisabled = true;
        } else {
            this.saveDisabled = false;
        }
        this.onChange();
        const contentEl = $(event.html).find('[data-denotation-char=""]');
        this.selectedUsersList = [];
        if(contentEl.length) {
            for (let i = 0; i < contentEl.length; i++) {
                let index = this.selectedUsersList.findIndex((data: any) => data == contentEl[i].dataset['id']);
                if(index < 0) {
                    this.selectedUsersList.push(contentEl[i].dataset['id']);
                }
            }
        }
    }

    getUserList() {
        if (this.usersList) {
            for (let index = 0; index < this.usersList.length; index++) {
                this.usersList[index]['value'] = this.usersList[index]['username'];
                this.users.push(this.usersList[index]);
            }
        }

    }

    prepareCallSavePayload() {
        const formValue = this.callForm ? this.callForm.value : {};
    
        return {
            ...formValue,
            customerId: this.userInfo && this.userInfo.customerId
                ? this.userInfo.customerId
                : formValue.customerId,
    
            callId: this.userInfo ? this.userInfo.callId : null,
            contactnumber: this.userInfo ? this.userInfo.contactnumber : null,
            direction: this.userInfo ? this.userInfo.direction : null,
            name: this.userInfo ? this.userInfo.name : null,
            address: this.userInfo ? this.userInfo.address : null,
            dialpad: this.userInfo ? this.userInfo.dialpad : 0,
            state: this.userInfo ? this.userInfo.state : 0
        };
    }
    
  

    // Dial Pad only - replaces the native <select> for a customField with the searchable
    // app-cs-drop-down (Angular-native; its search box/menu stay inside the modal's own DOM,
    // unlike jQuery Select2 which appends to <body> and gets its focus stolen back by this
    // modal's legacy Bootstrap enforceFocus - see call-log-modal.component.html).
    buildCustomFieldDdConfig(cf: any): ICsDropDown {
        const currentValue = this.customFieldForm && this.customFieldForm.value ? this.customFieldForm.value[cf.key] : null;
        return {
            id: `custom_field_${cf.key}`,
            // custom-fields-section sits right above the modal footer, with little room below
            // and .modal-body clipping overflow - opening upward keeps the menu on screen.
            isDropUp: true,
            ddTogglerConfig: {
                templateType: 'BTN_TRANSPARENT',
                templateData: {
                    text: (currentValue && currentValue.description) || '-- Please select --'
                }
            },
            ddMenuConfig: {
                isSearchBar: true,
                templateType: 'BASIC',
                items: (cf.value || [])
                    .filter((value: any) => value.archived != 1)
                    .map((value: any) => ({
                        id: value.id,
                        templateData: { text: value.description },
                        itemData: value
                    }))
            }
        };
    }

    onCustomFieldDdSelect(cf: any, item: ICsDdItem): void {
        this.customFieldForm.controls[cf.key].setValue(item.itemData);
    }

    // Dial Pad only - keeps each dropdown's toggler text in sync after an edit-mode
    // customFieldForm.patchValue() sets a value the dropdown wasn't built with.
    refreshCustomFieldDdTogglerText(): void {
        this.customFields.forEach((cf: any) => {
            if (!cf.ddConfig) {
                return;
            }
            const currentValue = this.customFieldForm.value[cf.key];
            cf.ddConfig.ddTogglerConfig.templateData.text = (currentValue && currentValue.description) || '-- Please select --';
        });
    }

    saveCallCommunication() {
        let callData = this.prepareCallSavePayload();
        
        if(this.customFieldForm.valid && this.customFieldForm.value) {
            callData.callCustomField = this.customFieldForm.value;
        }
      
        this.integrationsService.postdialpadActivityCall(callData).subscribe(resp => {
            if (resp['statusCode'] == 200) {
                // Missed calls follow the same "call complete" scenario as hangup calls -
                // it moves the bar into recap_summary and then auto-removes it.
                if (callData.state == 'hangup' || callData.state == 'missed') {
                    this.sendValue.emit({
                        callId: callData.callId,
                        callstate: 'call complete',
                      });
                }
                this.closeModal();
            }
            else if (resp['error'] != 200) {
            }
        })

    }
}
